import { render, staticRenderFns } from "./DevPageKS1.vue?vue&type=template&id=4e4170d6&scoped=true"
import script from "./DevPageKS1.vue?vue&type=script&lang=js"
export * from "./DevPageKS1.vue?vue&type=script&lang=js"
import style0 from "./DevPageKS1.vue?vue&type=style&index=0&id=4e4170d6&prod&lang=css"
import style1 from "./DevPageKS1.vue?vue&type=style&index=1&id=4e4170d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4170d6",
  null
  
)

export default component.exports